import { render, staticRenderFns } from "./LenderReviews.vue?vue&type=template&id=28c13668&"
import script from "./LenderReviews.vue?vue&type=script&lang=js&"
export * from "./LenderReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports